import { useMsal } from '@azure/msal-react'
import { loginRequest } from '@modules/msal/MSAL'
import { Button, Space, Typography } from 'antd'
import { useState } from 'react'

const { Title } = Typography

const Login = () => {
  const { instance } = useMsal()
  const [_, setAnchorEl] = useState(null)

  const handleLogin = (loginType: string) => {
    setAnchorEl(null)

    if (loginType === 'popup') {
      instance.loginPopup(loginRequest)
    } else if (loginType === 'redirect') {
      instance.loginRedirect(loginRequest)
    }
  }

  return (
    <Space vertical style={{ padding: 20, textAlign: 'center' }} size={20}>
      <img src="assets/linear_logo.png" width={300} />
      <Title style={{ margin: 0, marginBottom: '1rem' }}>
        Rock Your Career
      </Title>
      <Button
        style={{ background: '#293348', color: '#fff' }}
        size="large"
        onClick={() => handleLogin('redirect')}
      >
        Login
      </Button>
    </Space>
  )
}

export default Login
